module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.sidebarActiveButton === 'style'
    },
    attrs: {
      "title": _vm.$t('general.labels.edition')
    },
    on: {
      "click": function($event) {
        _vm.sidebarChangePanel('style');
        _vm.sidebarChangeActiveButton('style');
        _vm.canvasChangeView('preview')
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-brush"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-00ab6d9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/buttons/types/Style.vue
 ** module id = 743
 ** module chunks = 1
 **/